import { NgModule } from '@angular/core';
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpBatchLink } from 'apollo-angular/http';
import { ApolloClientOptions, InMemoryCache, DefaultOptions } from '@apollo/client/core';
import { environment } from '@env/environment';

export function createApollo(httpBatchLink: HttpBatchLink): ApolloClientOptions<any> {
  const defaultOptions: DefaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  };

  return {
    link: httpBatchLink.create({ uri: environment.graphQlEndpoint }),
    cache: new InMemoryCache({ resultCaching: false, addTypename: false }),
    defaultOptions,
    connectToDevTools: !environment.production,
  };
}

@NgModule({
  providers: [
    HttpBatchLink,
    Apollo,
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpBatchLink],
    },
  ],
})
export class GraphQLModule {}
